import { Textarea } from "../../textarea/textarea";

import { QuestionWithHeaderAndFooter } from "../question";

import { QuestionContent } from "../question-content";
import { EssayQuestionProps } from "../types";

export const EssayQuestion = (props: EssayQuestionProps) => {
  const {
    gap,
    required,
    invalid,
    labelClassName,
    className,
    layoutProps,
    questionId,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    answer,
    placeholder,
    size,
    disabled,
    changeEventHandler,
    answerAriaLabel,
    answerProps,
    contentClassName,
    footerStackSpacing,
    note,
    maxNote,
    maxLength,
    errorMessage,
    errorMessageProps,
    withErrorIcon,
    noteProps,
    locale,
    answerDataTestId
  } = props;

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    if (maxLength && event.target.value.length > maxLength) {
      // Prevent adding characters beyond maxLength
      return;
    }
    changeEventHandler(event);
  };

  const headerFooterProps = {
    gap,
    required,
    invalid,
    questionId,
    labelClassName,
    className,
    layoutProps,
    questionLabel,
    accessibilityTextOfRequired,
    questionLabelProps,
    footerStackSpacing,
    answerLength: answer?.length,
    note,
    maxLength,
    maxNote,
    errorMessage,
    errorMessageProps,
    noteProps,
    withErrorIcon,
    locale
  };

  return (
    <QuestionWithHeaderAndFooter {...headerFooterProps}>
      <QuestionContent>
        <Textarea
          id={questionId}
          value={answer}
          className={contentClassName}
          disabled={disabled}
          onChange={handleChange}
          placeholder={placeholder}
          aria-label={answerAriaLabel}
          {...answerProps}
          size={size}
          data-testid={answerDataTestId}
        />
      </QuestionContent>
    </QuestionWithHeaderAndFooter>
  );
};
